import { useSearchParams } from "react-router-dom-v5-compat";
import { RBC_PACKAGES_QUERY_PARAM } from "@tenant/types";

export const useIsUpSell = (): boolean => {
  const [searchParams] = useSearchParams();
  return searchParams.get(RBC_PACKAGES_QUERY_PARAM.upSell) === "true";
};
